import AddQuantityModalView from "./addQuantityModal.html";


angular.module("gifts")

    .controller("GiftsEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$timeout', '$sce', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal',
        function (LoginService, $scope, $rootScope, $state, $timeout, $sce, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {

            $scope.changesNotSaved = false;
            $scope.errorUnits = false;
            let quantityAdd = 0;

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("GIFTS_WRITE");

            $rootScope.title = $filter('translate')('gifts.title');

            $scope.gridWarehouse = { warehouse_id: 1, entity_type: 'gifts' };

            var trusted = {};
            $scope.getPopoverContent = function (html) {
                return trusted[html] || (trusted[html] = $sce.trustAsHtml(html));
            };

            $scope.loadWharesouseRows = function () {
                Restangular.all('Warehouses').getList({ entity_type: "gifts", entity_id: $stateParams.id }).then(function (warehouses) {
                    $scope.selectWarehouses = warehouses;
                    $scope.gridWarehouse.warehouse_id = $scope.selectWarehouses[0].id;
                });
            }

            $scope.loadWharesouseRows();

            Restangular.all('Providers').getList().then(function (providers) {
                $scope.selectProviders = providers;
            });


            $scope.gift = {};

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('gifts.title'), url: "gifts.list" },
                    { title: $filter('translate')('gifts.title_add') },
                ];

            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('gifts.title'), url: "gifts.list" },
                    { title: $filter('translate')('gifts.title_edit') },
                ];

                Restangular.one('Gifts', $stateParams.id).get().then(function (result) {
                    $scope.gift = result;
                });
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('gifts.button_delete'),
                    message: $filter('translate')('gifts.delete_message') + " " + $scope.gift.name + "?",
                    onAccept: function () {
                        $scope.gift.remove().then(function () {
                            toastr.success($filter('translate')('gifts.delete_success'));
                            $state.go("gifts.list");
                        });
                    }
                });
            };

            $scope.allowViewPersonGifts = LoginService.permissionExist("PERSONS_GIFTS_READ"); //Solo se mostrara si tiene permiso para ver los regalos a las personas

            $scope.loadGrid = function () {
                if (angular.isDefined($scope.gridOptionMovementsGifts)) {
                    $scope.gridOptionMovementsGifts.loadData(false);
                } else {
                    $scope.gridOptionMovementsGifts = {
                        enableSorting: true,
                        paginationPageSizes: [20, 40, 60],
                        paginationPageSize: 20,

                        onRegisterApi: function (gridApi) {
                            this.gridApi = gridApi;
                        },
                        columnDefs: [
                            { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                            { name: 'created_at', displayName: $filter('translate')('movement.date'), cellFilter: 'toUniversalDateCreatedAtHack | date:\'dd/MM/yyyy HH:mm\'', enableColumnMenu: false },
                            { name: 'provider_name', field: 'provider_name', displayName: $filter('translate')('gifts.provider'), enableHiding: false },
                            { name: 'destination_name', field: 'destination_name', displayName: $filter('translate')('movement.destination'), enableHiding: false },
                            {
                                name: 'direction', field: 'direction', displayName: $filter('translate')('movement.direction'), enableHiding: false,
                                cellTemplate: '<div ng-if="row.entity.direction==\'OUT\'" class="ui-grid-cell-contents"><span class="fa fa-arrow-down" style="color:red">&nbsp;Saliente</span></div><div ng-if="row.entity.direction==\'IN\'" class="ui-grid-cell-contents"><span class="fa fa-arrow-up" style="color:#00AE00">&nbsp;Entrante</span></div>'

                            },
                            { name: 'warehouse_name', field: 'warehouse_name', displayName: $filter('translate')('gifts.warehouse'), enableHiding: false },
                            { name: 'quantity', field: 'quantity', displayName: $filter('translate')('movement.quantity'), enableHiding: false , width: 100},
                            { name: 'final_quantity', field: 'final_quantity', displayName: $filter('translate')('movement.final_quantity'), enableHiding: false, width: 150 },
                            {
                                name: 'notes', field: 'notes', displayName: $filter('translate')('general.notes'), enableHiding: false, width: 300,
                                cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope"><span><a class= "aColorBlack" popover-placement="top" popover-trigger="mouseenter" uib-popover-html="grid.appScope.getPopoverContent(row.entity.notes)" popover-append-to-body="true" >{{row.entity.notes}}</a></span></div>',
                            },
                        ],
                        getData: function (options) {
                            options.warehouse_id = $scope.gridWarehouse.warehouse_id;
                            options.entity_type = $scope.gridWarehouse.entity_type;
                            options.entity_id = $stateParams.id;
                            return Restangular.all('WarehousesMovements').getList(options);
                        }
                    };
                }
            }

            $scope.loadGrid();

            $scope.changeTab = function (warehouse_id) {
                $scope.gridWarehouse.warehouse_id = warehouse_id;
                $scope.loadGrid();
            }

            $scope.saveGift = function () {
                if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
                    Restangular.all('Gifts').post($scope.gift).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('gifts.save_success'));
                            $scope.gift = result;
                            $stateParams.id = result.id;
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    $scope.gift.put().then(function (result) {
                        toastr.success($filter('translate')('materials.edit_success'));
                    });
                }
            }


            $scope.selectImage = function () {
                $("#frmImage").trigger("click");
                $("#frmImage").change(function () {
                    const fileInput = document.querySelector('#frmImage') as HTMLInputElement;
                    const file = fileInput?.files?.[0];
                    if (file) {
                        const fileReader = new FileReader();
                        fileReader.onload = function (event) {
                            const uri = (event.target as FileReader).result;
                            if (angular.isUndefined($scope.gift.FK_gifts_images) || $scope.gift.FK_gifts_images == null) $scope.gift.FK_gifts_images = {};
                            $scope.gift.FK_gifts_images.image = uri;
                            $scope.gift.photo = uri;
                            $scope.gift.image_id = null; //??
                            if (!$scope.$$phase) $scope.$apply();
                        };
                        fileReader.readAsDataURL(file);
                    } else {
                        //preview.src = "";
                        $scope.removeImage();
                    }
                });
            };

            $scope.getImage = function () {
                if ($scope.gift.FK_gifts_images != null && $scope.gift.FK_gifts_images.image != null) {
                    return $scope.gift.FK_gifts_images.image;
                } else if ($scope.gift.image_id != null) {
                    return "/api/Image/GetImageBmp?id=" + $scope.gift.image_id + "&maxW=150&maxH2=150";
                } else {
                    return "assets/img/no-image.png";
                }
            };

            $scope.removeImage = function ($event) {
                $scope.gift.image_id = null;
                if ($scope.gift.FK_gifts_images != null) $scope.gift.FK_gifts_images.image = null;
                $event.preventDefault();
                $event.stopPropagation();
            };

            $scope.checkChanges = function () {
                $scope.changesNotSaved = true;
            }

            $scope.addQuantities = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddQuantityModalView,
                    size: "sm",
                    controller: "AddQuantitiesGiftsModalCrl",
                    resolve: {
                        giftId: function () { return $stateParams.id }
                    }
                });

                // Response del modal
                $modalInstance.result.then(function (movement) {
                    Restangular.all('WarehousesMovements').post(movement).then(function (res) {
                        toastr.success($filter('translate')('materials.edit_success'));
                        Restangular.one('Gifts', $stateParams.id).get().then(function (result) {
                            $scope.gift = result;
                            $timeout(function () {
                                $scope.loadWharesouseRows();
                                $scope.loadGrid();
                            }, 200);
                        });
                    });
                }, function () { });
            }
        }])
    .controller("AddQuantitiesGiftsModalCrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'giftId', function ($scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, giftId) {

        $scope.movement = { wharehouse_id: null, quantity: 0 };
        $scope.selectWarehouses = [];
        Restangular.all('Warehouses').getList().then(function (warehouses) {
            $scope.selectWarehouses = warehouses;
        });

        $scope.onSave = function () {
            Restangular.all('Warehouses').customGET("GetTotalStockInWarehouse", { warehouse_id: $scope.movement.warehouse_id, product_id: giftId, type: "gifts" }).then(function (res) {
                $scope.totalStock = res;
                //Comprobamos con los numeros negativos que no pongan menos cantidad de la que hay
                if ($scope.movement.quantity < 0) {
                    if (parseInt($scope.movement.quantity) < $scope.totalStock * -1) {
                        $scope.errorUnits = true;
                    }
                    else
                        $scope.errorUnits = false;
                }

                if (!$scope.errorUnits) {
                    let movement = {
                        gift_id: giftId,
                        warehouse_id: $scope.movement.warehouse_id,
                        direction: $scope.movement.quantity > 0 ? 'IN' : 'OUT',
                        quantity: $scope.movement.quantity,
                        notes: $scope.movement.notes
                    }
                    $uibModalInstance.close(movement);
                }
            });
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }])

;

